import { render, staticRenderFns } from "./inviteHeader.vue?vue&type=template&id=6df09733&scoped=true&"
import script from "./inviteHeader.vue?vue&type=script&lang=js&"
export * from "./inviteHeader.vue?vue&type=script&lang=js&"
import style0 from "./inviteHeader.vue?vue&type=style&index=0&id=6df09733&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df09733",
  null
  
)

export default component.exports